import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap-modal'

const GoogleConflictWarning = (props) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(props.googleConflict)
  }, [props.googleConflict])

  return (
    <Modal container={document.body} show={show} onHide={props.onClose} dialogClassName='googleConflictWarning'>
      <Modal.Header closeButton>
        <Modal.Title>Warning: Scheduling Conflict</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          There is a conflicting event at the time you are trying to {props.type == 'schedule' ? 'schedule' : 'confirm'}
          &nbsp;this game titled: {props.googleConflict && props.googleConflict.gameName}. Are you sure you want
          to {props.type == 'schedule' ? 'post' : 'confirm'} this game?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onClose} className='btn btn-default'>Cancel</button>
        <button onClick={props.onConfirm} className='btn btn-success'>{props.type == 'schedule' ? 'Post' : 'Confirm'} Anyway</button>
      </Modal.Footer>
    </Modal>
  )
}

export default GoogleConflictWarning
